import {useMutation} from "react-query";
import {MAKE_BULK_REFUND_DECISION, MAKE_REFUND_DECISION} from "./graphql";
import {apollo} from "./apollo";
import {toast} from "react-toastify";
import {clearCachedKey} from "./helpers";

export const useMakeRefundDecisionMutation = () => {
    return useMutation({
        mutationKey: 'make_refund_decision',
        mutationFn: async ({refundUuid, refundDecision, otp}) => {
            const {data} = await apollo.mutate({
                mutation: MAKE_REFUND_DECISION,
                variables: {
                    otp: otp,
                    refundUuid: refundUuid,
                    refundDecision: refundDecision,
                },
            });
            return data?.makeRefundDecision;
        },
        onSuccess: (data) => {
            if (data?.success && data?.message) {
                toast.success(data.message);
            } else if (!data?.success && data?.message) {
                toast.error(data.message);
            }
        },
        onSettled: () => {
            clearCachedKey(['refund_view'])
        }
    });
};

export const useMakeBulkRefundDecisionMutation = () => {
    return useMutation({
        mutationKey: 'make_bulk_refund_decision',
        mutationFn: async ({bulkRefundUuid, refundDecision, otp}) => {
            const {data} = await apollo.mutate({
                mutation: MAKE_BULK_REFUND_DECISION,
                variables: {
                    otp: otp,
                    bulkRefundUuid: bulkRefundUuid,
                    refundDecision: refundDecision,
                },
            });
            return data?.makeBulkRefundDecision;
        },
        onSuccess: (data) => {
            if (data?.success && data?.message) {
                toast.success(data.message);
            } else if (!data?.success && data?.message) {
                toast.error(data.message);
            }
        },
        onSettled: () => {
            clearCachedKey(['refund_list'])
        }
    });
};
